<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip v-if="Boolean(file)" bottom v-bind="attrs" v-on="on">
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-btn x-small text @click.stop="openDialog"
              ><v-icon small>mdi-pencil</v-icon></v-btn
            >
          </span>
        </template>
        <span> Edit </span>
      </v-tooltip>
      <v-btn
        v-else
        v-on="on"
        v-bind="attrs"
        small
        color="primary"
        @click="openDialog"
        ><v-icon left>mdi-upload</v-icon>Upload File</v-btn
      >
    </template>

    <v-card class="primary--text" v-if="dialog">
      <validation-observer ref="form" v-slot="{ invalid }">
        <v-card-title>
          {{ Boolean(file) ? "Edit Document" : "Upload File" }}
        </v-card-title>
        <v-card-text @drop.prevent="addDropFile" @dragover.prevent class="pt-0">
          <validation-provider
            v-if="!Boolean(file)"
            ref="fileInputRef"
            :rules="{ required: true, validFileName: true }"
            v-slot="{ errors }"
          >
            <v-file-input
              v-model="selectedFiles"
              prepend-icon="mdi-paperclip"
              label="Select File(s)"
              single-line
              multiple
              chips
              :error-messages="errors"
            >
              <template v-slot:selection="{ index, text }">
                <v-chip close @click:close="removeFile(index)">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
          </validation-provider>
          <validation-provider
            v-else
            :rules="{ required: true, validFileName: true }"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="fileName"
              label="File Name"
              prepend-icon="mdi-paperclip"
              :suffix="fileExtension"
              :error-messages="errors"
            ></v-text-field>
          </validation-provider>
          <validation-provider :rules="{ required: true }" v-slot="{ errors }">
            <v-autocomplete
              v-model="documentTypeId"
              item-value="documentTypeId"
              item-text="name"
              prepend-icon="mdi-tag-outline"
              label="Document Type"
              :items="documentTypes"
              :error-messages="errors"
            ></v-autocomplete>
          </validation-provider>
          <v-select
            v-if="Boolean(plans)"
            v-model="planId"
            :items="plans"
            :item-text="
              (item) => `${item.planType} - ${item.formattedStartDate}`
            "
            item-value="planId"
            label="Attach to  plan (optional)"
            prepend-icon="mdi-link-variant"
            clearable
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :dark="!loading"
            :disabled="loading"
            text
            @click="clear"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :dark="!loading && !invalid"
            :disabled="loading || invalid"
            text
            @click.once="upload"
            >Save</v-btn
          >
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["clientId", "documentType", "file", "ageCategory"],
  data() {
    return {
      dialog: false,
      selectedFiles: [],
      loading: false,
      planId: null,
      documentTypeId: null,
      fileName: "",
      fileExtension: "",
    };
  },
  computed: {
    documentTypes: function () {
      return this.$store.getters[
        "optionsModule/getDocumentTypesForAgeCategory"
      ](this.ageCategory);
    },
    plans() {
      return this.$store.state.plansModule.plans.filter(
        (item) => item.ageCategory == this.ageCategory
      );
    },
  },
  methods: {
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
      this.$refs.fileInputRef.validate(this.selectedFiles);
    },
    openDialog() {
      if (Boolean(this.file)) {
        this.documentTypeId = this.documentType.documentTypeId;
        var lastIndex = this.file.fileName.lastIndexOf(".");
        this.fileName = this.file.fileName.slice(0, lastIndex);
        this.fileExtension = this.file.fileName.slice(lastIndex);
        this.planId = this.file.planId;
      }
      this.dialog = true;
    },
    addDropFile(e) {
      this.selectedFiles.push(...Array.from(e.dataTransfer.files));
      this.$refs.fileInputRef.validate(this.selectedFiles);
    },
    async upload() {
      this.loading = true;
      let success;
      // update
      if (Boolean(this.file)) {
        success = await this.$store.dispatch(
          "clientModule/updateClientDocument",
          {
            fileId: this.file.fileId,
            documentTypeId: this.documentTypeId,
            fileName: this.fileName + this.fileExtension,
            planId: Boolean(this.planId) ? this.planId : null,
          }
        );
      } else {
        // create
        success = await this.$store.dispatch(
          "clientModule/uploadFilesForClient",
          {
            clientId: this.clientId,
            documentTypeId: this.documentTypeId,
            files: this.selectedFiles,
            planId: Boolean(this.planId) ? this.planId : null,
          }
        );
      }
      if (!success) {
        this.$store.commit("uxModule/setSnackbarMsg", "Error saving changes.");
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.loading = false;
      this.clear();
    },
    clear() {
      this.$refs.form.reset();
      this.selectedFiles = [];
      this.documentTypeId = null;
      this.planId = null;
      this.dialog = false;
    },
  },
};
</script>
